import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "../../ui/button";
import { getCtaHighlights } from "../content";
import { Reveal } from "../hooks";

export function FinalCTASection({ platformStats }) {
  const ctaHighlights = getCtaHighlights(platformStats);

  return (
    <section
      className="py-24 px-4 bg-[#0A0A0A] relative overflow-hidden"
      data-testid="final-cta"
    >
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[700px] pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, hsla(221, 100%, 50%, 0.18) 0%, transparent 60%)",
        }}
      />
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <Reveal>
          <div className="text-white/50 text-xs font-mono font-medium uppercase tracking-widest mb-4">
            STUDY SMARTER
          </div>
          <h2 className="text-3xl sm:text-4xl font-cabinet font-black text-white mb-5 leading-tight tracking-tight">
            Your data knows where
            <br />
            to focus. Do you?
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-white/60 text-lg mb-8 font-plex max-w-lg mx-auto">
            Replace guesswork with percentile tracking, time analysis, and
            section insights. Start free and see your analytics from day one.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/signup">
              <Button
                size="lg"
                className="bg-white text-[#0A0A0A] hover:bg-white/90 text-base font-bold font-cabinet rounded-full px-8 group"
                data-testid="cta-signup"
              >
                Get Started{" "}
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/login">
              <Button
                size="lg"
                variant="outline"
                className="border-white/20 text-white hover:bg-white/10 text-base font-plex rounded-full px-8"
              >
                Log In
              </Button>
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.35}>
          <div className="flex flex-wrap justify-center gap-6 mt-8 text-white/50 text-sm font-plex">
            {ctaHighlights.map((t) => (
              <span key={t} className="flex items-center gap-1.5">
                <CheckCircle2 className="h-4 w-4 text-white/40" /> {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
